<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">疫苗驱虫套餐列表</div>
				<div class="titleR">
					<el-button type="warning" plain size="small" @click="back">返回</el-button>
				</div>
			</div>
			<div class="content">
				<div class="con">
					<div class="tabLine">
						<div class="tabLineL">
							<div class="tabItem" :class="[tabIndex===0?'active':'']" @click="changeTabIndex(0)">疫苗套餐</div>
							<div class="tabItem" :class="[tabIndex===1?'active':'']" @click="changeTabIndex(1)">驱虫套餐</div>
						</div>
						<div class="tabLineR"></div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							<el-input style="width:180px;margin-right: 10px;" placeholder="请输入关键字" v-model="search.keyword" @keyup.enter.native="clickSearch" clearable size="small"></el-input>
							<el-button @click="clickSearch" type="warning" size="small">搜索</el-button>
							<div class="searchLabel">选择门店</div>
							<el-select style="width:120px" v-model="search.shopId" placeholder="请选择" @change="changeSearch" size="small">
								<el-option v-for="item in shopsList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
								</el-option>
							</el-select>
							<div class="searchLabel">宠物类别</div>
							<el-select style="width:100px" v-model="search.applytype" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:''},{label:'犬类',value:'1'},{label:'猫类',value:'2'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="searchLineR"></div>
					</div>
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="套餐名称" prop="title" >
							</el-table-column>
							<el-table-column label="套餐类别" prop="recordId">
								<template slot-scope="props">
									{{props.row.category_info.name}}
								</template>
							</el-table-column>
							<el-table-column label="宠物类型" prop="memberName">
								<template slot-scope="props">
									{{props.row.apply_type.title}}
								</template>
							</el-table-column>
							<el-table-column label="操作">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="$router.push({path:'/yiliao/ymqcSee?id='+props.row.id})">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				shopsList: [],
				search:{
					applytype:'',     //  0通用；1犬类；2猫类  
					keyword:'',
					shopId:'',
					begin_time:'',
					end_time:'',
				},
				tableData:[],
				tabIndex:0,
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			ymqcParams(){
				return this.$store.state.yiliaoxin.ymqcParams;
			},
		},
		beforeRouteEnter(to,from,next){
			next(vm=>{
				if(vm.page.page===1){
					vm.getTableData();
				}
			})
		},
		created(){
			let shopsList =  JSON.parse(JSON.stringify(this.$store.getters['shopList']));
			if(shopsList[0]&&shopsList[0].shop_name!=='全部'){
				shopsList.unshift({shop_id:'',shop_name:'全部'})
			}
			this.shopsList = shopsList;
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// 返回
			back(){
				this.ymqcParams.type = 'list'
				this.$store.commit("yiliaoxin/set_ymqcParams",this.ymqcParams)
			},
			// reset(){
			// 	this.search.petType='';
			// 	this.search.serviceTypeId=0;
			// 	this.search.isPay=-1;    // 是否支付
			// 	this.search.keyword='';
			// 	this.search.shopId='';
			// 	this.page.page=1;
			// 	this.getTableData()
			// },
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			// 切换列表
			changeTabIndex(index){
				this.tabIndex=index;
				this.page.page=1;
				this.getTableData()
			},
			getTableData(){
				let categoryId = ''
				if(this.tabIndex===0){
					categoryId = '604323824335a2f958dc740b'
				}else if(this.tabIndex===1){
					categoryId = '604323824335a2f958dc740d'
				}
				let params = {
					"applytype": this.search.applytype, // 0通用；1犬类；2猫类
					"categoryId": categoryId,
					"shopId": this.search.shopId,
					"buyWay": "",  // 0: 卖赠 1:折扣 2:自定义
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": this.search.keyword,
				}
				// if(this.datetimerange&&this.datetimerange.length==2){
				// 	params.begin_time=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
				// 	params.end_time=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				// }
				let loading=this.$loading();
				this.$http.post('/api/Product/Vaccine/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;display: flex;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
